export default __webpack_public_path__ + "static/media/dayparty2019.392f46ae.jpg";